export const SHOW_DISABLED_ENVIRONMENTS = "frontend.show.disabled.environments";

export function isDisabledEnvironmentFlag(environment) {
    const v = environment?.disabled;
    if (v === true || v === false) {
        return v;
    }
    return String(v ?? "").toLowerCase() === "true";
}

export function isAllowedToAccessEnvironment(environment) {
    return environment?.allowedToAccess?.toString() === "true";
}

export function isEnvironmentBlocked(environment) {
    return isDisabledEnvironmentFlag(environment) || !isAllowedToAccessEnvironment(environment);
}
